// @ts-nocheck
import _axios from "axios"
import store from "../../store"
const OVERRIDE_SERVER = process.env.REACT_APP_OVERRIDE_SERVER;
const HOSTS = {
	"my.salusion.com": "https://backend.salusion.com/v1/",
	"my.salusion-staging.com": "https://backend.salusion-staging.com/v1/",
	"my.salusion-preprod.com": "https://backend.salusion-preprod.com/v1/",
	"my.salusion-production.com": "https://backend.salusion-production.com/v1/"
}

// assume OVERRIDE_SERVER is defined globally (e.g. via webpack DefinePlugin or script injection)
let HOST = HOSTS[window.location.hostname]
// if (process.env.CODESPACE_ACCOUNT?.toUpperCase() === "TRUE") {
// 	HOST = HOSTS["my.salusion-staging.com"]
// }

export const salusionURL = HOST || OVERRIDE_SERVER || "https://backend.salusion.com/v1/"

export default async function Axios(args) {
	const { method, target, payload, token, options } = args

	let url = salusionURL + target
	if (options?.disablePrefix) url = target

	const headers = { Authorization: `Bearer ${token}` }
	const data = payload || null

	const request = { headers, method, url, data }

	if (Boolean(OVERRIDE_SERVER)) request.headers["x-env"] = "x-env"
	if (options?.responseType) request.responseType = options.responseType

	function onSuccess(response) {
		return response
	}

	function onError(error) {
		const errorCode = error?.response?.data?.code
		const errorMessage = error?.response?.data?.message

		const enrollment = window.location.pathname.includes("enrollment")
		const customerView = store?.user?.isSeanOrCustomer

		if (errorCode === "employer_g-03") return null
		else if (errorCode === "101-02") {
			if (enrollment) return new Error()
			return store.invalidateUser({})
		}

		if (errorMessage) {
			store.setNotification("notification", true, { msg: errorMessage, severity: "error" })
		}

		if (!errorCode && customerView) {
			window.location.href = "/error"
		}

		return Promise.reject(error)
	}

	const axios = _axios.create()
	axios.interceptors.response.use(onSuccess, onError)

	return axios(request)
}
